<template>
  <div class="row justify-content-center">
    <div class="col-12 col-md-8">
      <div class="card mt-3">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <h5 class="fw-bold mb-0 text-black-50">
              <i class="fa-solid fa-square-plus"></i>
              Create New Category
            </h5>
            <RouterLink to="category-lists" class="btn btn-outline-primary">
              <i class="fa-solid fa-list"></i>
            </RouterLink>
          </div>
          <hr>
          <form action="" class="">
            <div class="row g-2">
              <div class="col-9">
                <div class="form-floating mb-3">
                  <input type="text"
                         class="form-control"
                         id="floatingInput"
                         placeholder="category">
                  <label for="floatingInput">Enter New Category</label>
                </div>
              </div>
              <div class="col-3">
                <button class="btn btn-lg btn-primary w-100 mt-1">Add</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CreateView"
}
</script>

<style scoped>

</style>